import storyline from '../../../storyline'
const initialState = {
  ...storyline,
}

const actionsMap = {}

/* eslint require-jsdoc: 0 */
export function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
